// Curva térmica del 020 (Fase 1 del roadmap de formularios MSP — ver
// PLAN.md): temperatura/frecuencia cardíaca/frecuencia respiratoria en el
// tiempo, el gráfico de enfermería a pie de cama que el 020 exige y que hoy
// no existe (el formulario ya captura estos 3 signos como Observation
// individuales — ver formulario/discretos/Formulario020.tsx — esto solo los
// grafica). Puro — sin React, sin recharts, sin fetch — para poder testear
// con Vitest sin DOM, mismo patrón que formulario/discretos/enfermeria.ts.
import type { Observation } from '@medplum/fhirtypes';
import { SIGNOS_VITALES } from '../formulario/discretos/vitalSigns';
import { PALETA_SERIES } from '../graficos/tema';
import type { Serie } from '../graficos/tipos';

/** Los 3 signos que oficialmente forman la curva térmica del 020 — en este orden fijo (define el color/trazo asignado). */
const CLAVES_CURVA_TERMICA = ['temperatura', 'fc', 'fr'] as const;

const DEFINICIONES = CLAVES_CURVA_TERMICA.map((clave) => {
  const def = SIGNOS_VITALES.find((s) => s.clave === clave);
  if (!def) throw new Error(`vitalSigns.ts no define el signo "${clave}"`);
  return def;
});

/**
 * Agrupa Observations de signos vitales por LOINC (temp/FC/FR), descarta las
 * que no tienen `valueQuantity`/`effectiveDateTime`, ordena cada grupo por
 * fecha ascendente (SignosVitalesTab trae `-date` descendente; el gráfico
 * necesita el orden inverso) y las traduce a Serie[] para
 * GraficoSerieTemporal. Un signo sin ninguna medición no genera una Serie
 * vacía (evita entradas fantasma en la leyenda).
 */
export function seriesCurvaTermicaDe(observaciones: readonly Observation[]): Serie[] {
  const series: Serie[] = [];
  DEFINICIONES.forEach((def, indice) => {
    const puntos = observaciones
      .filter((o) => o.code?.coding?.some((c) => c.system === 'http://loinc.org' && c.code === def.loinc))
      .filter((o): o is Observation & { effectiveDateTime: string; valueQuantity: { value: number } } => typeof o.effectiveDateTime === 'string' && typeof o.valueQuantity?.value === 'number')
      .map((o) => ({ x: new Date(o.effectiveDateTime).getTime(), y: o.valueQuantity.value }))
      .sort((a, b) => a.x - b.x);
    if (puntos.length === 0) return;
    const { color, trazo } = PALETA_SERIES[indice % PALETA_SERIES.length];
    series.push({ id: def.clave, etiqueta: def.etiqueta, color, trazo, unidad: def.unidad, puntos });
  });
  return series;
}

/** true si ALGUNA serie tiene al menos 2 puntos — umbral mínimo para que una línea tenga sentido clínico. */
export function hayDatosSuficientes(series: readonly Serie[]): boolean {
  return series.some((s) => s.puntos.length >= 2);
}
